import { ValuesMap } from '../types/ValuesMap';

export const fromValuesMap = <V extends unknown>(
  valuesMap: ValuesMap<V>,
): V[] => {
  return Object.entries(valuesMap)
    .filter(([_v, isTrue]) => isTrue)
    .map(([v]) => v as V);
};
